import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OverlayMessageComponent } from './overlay-message.component';

@NgModule({
  imports: [CommonModule],
  declarations: [OverlayMessageComponent],
  exports: [OverlayMessageComponent],
})
export class OverlayMessageModule {}
